import React, { useEffect } from 'react'
import { Col, Row, Card } from "react-bootstrap";
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { getHotelsList } from '../../../store/slices/general/thunks';
import { setRoomCategoryFilter, setRoomCategoryList } from '../../../store/slices/catalogue/catalogueSlice';
import { RoomCategoryTable } from './RoomCategoryTable';
import { AddRoomCategory } from './AddRoomCategory';
import { FormSearchRoomCategory } from './FormSearchRoomCategory';

export const RoomCategoryScreen = () => {
  const dispatch = useDispatch();
  const [add, setAdd] = useState(false);

  useEffect(() => {
    dispatch(getHotelsList())

    return () => {
      dispatch(setRoomCategoryList([]))
      dispatch(setRoomCategoryFilter({hotel:0}));
    }
  }, [dispatch])

  return (
    <div>

      <div className="d-flex justify-content-end" style={{ marginTop: 20, marginBottom: 20 }} >
        <button className="btn btn-primary btn-icon text-white"
          onClick={() => setAdd(true)}>Agregar Categoría de Habitación</button>
        <AddRoomCategory isOpen={add} setIsOpen={setAdd} />
      </div>

      <FormSearchRoomCategory />
      <Row>
        <Col sm={12} className="col-12">
          <Card>
            <Card.Header>
              <h3 className="card-title mb-0">Categorías de Habitación</h3>
            </Card.Header>
            <Card.Body>
              <div className="dataTable">
                <div className="table-responsive">
                  <RoomCategoryTable />
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}
